var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.16602 9.91666L6.72453 4.20048C6.76062 4.16337 6.80345 4.13388 6.85059 4.11377C6.89777 4.09367 6.94833 4.08332 6.99935 4.08332C7.05037 4.08332 7.10093 4.09367 7.14811 4.11377C7.19524 4.13388 7.23807 4.16337 7.27416 4.20048L12.8327 9.91666",
    stroke: "#06038D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.7f88388d3f05668e738d19f084caea99.svg";
export { ForwardRef as ReactComponent };